module.exports = __webpack_public_path__ + "static/media/stackoverflow.52ab6a3e.svg";